import "./src/styles/global.css"

export const onClientEntry = () => {
  document.documentElement.style.boxSizing = "border-box"
}
